export default {
  title: 'Audiență test',
  columns: {
    id: 'Id',
    phone_number: 'Număr de telefon',
  },
  filters: {
    search: {
      placeholder: 'Căutare',
    },
  },
  buttons: {
    send_test: 'Trimite test',
  },
  feedback: {
    success: 'Trimis cu succes',
    error: 'Trimitere eșuată',
  },
};
